var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgThreeDotsVertical = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 3.15007C9.16667 3.7944 8.64433 4.31673 8 4.31673C7.35567 4.31673 6.83333 3.7944 6.83333 3.15007C6.83333 2.50573 7.35567 1.9834 8 1.9834C8.64433 1.9834 9.16667 2.50573 9.16667 3.15007ZM9.16667 7.9834C9.16667 8.62773 8.64433 9.15007 8 9.15007C7.35567 9.15007 6.83333 8.62773 6.83333 7.9834C6.83333 7.33907 7.35567 6.81673 8 6.81673C8.64433 6.81673 9.16667 7.33907 9.16667 7.9834ZM8 13.9897C8.64433 13.9897 9.16667 13.4674 9.16667 12.823C9.16667 12.1787 8.64433 11.6564 8 11.6564C7.35567 11.6564 6.83333 12.1787 6.83333 12.823C6.83333 13.4674 7.35567 13.9897 8 13.9897Z",
    fill: "#006EB7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThreeDotsVertical, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/three-dots-vertical.118f4294.svg";
export { ForwardRef as ReactComponent };